import { X } from "lucide-react";
import FilterCard from "../../shared/FilterCard";
import { useQuery } from "react-query";
import { getBranches } from "../../sdk/branch/branch";
import { getRoles } from "../../sdk/roles/roles";
import { useState } from "react";
import Calendar from "react-calendar";

const UserFilter = ({
  closeFilters,
  handleApplyFilter,
  status,
  setStatus,
  selectedRole,
  setSelectedRole,
  selectedBranch,
  setSelectedBranch,
  selectedGender,
  setSelectedGender,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
}) => {
  const [activeTab, setActiveTab] = useState("Status");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleStatusSelect = (label) => {
    setStatus(label);
  };

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
  };

  const handleBranchSelect = (branch) => {
    setSelectedBranch(branch);
  };

  const { data: roles } = useQuery({
    queryKey: ["roles"],
    queryFn: () => getRoles(),
  });

  const { data: branches } = useQuery({
    queryKey: ["branches"],
    queryFn: () => getBranches(),
  });

  const appliedFiltersCount = [
    status,
    selectedRole,
    selectedBranch,
    (selectedGender?.length ?? 0) > 0 ? "gender" : null,
    fromDate ? "fromDate" : null,
    toDate ? "toDate" : null,
  ].filter(Boolean).length;
  return (
    <div
      onClick={(e) => {
        closeFilters();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[750px] h-[550px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeFilters}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[10px] right-[20px] flex items-center gap-[10px]">
          <button
            onClick={() => {
              setStatus("");
              setSelectedRole("");
              setSelectedBranch("");
              setSelectedGender("");
              setFromDate(null);
              setToDate(null);
            }}
            className="h-[35px] bg-[#FFFFFF] border border-[#000000] rounded-[30px] px-[15px] text-[15px] font-bold text-[#000000]"
          >
            Clear Filters
          </button>
          <button
            onClick={handleApplyFilter}
            className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            Apply Filters
          </button>
        </div>
        <div className="w-full">
          <p className="text-[#000000] text-[20px] font-medium">Filters</p>
          <p className="w-[90%] text-[#5C5C5C] text-[14px] font-normal">
            Refine your view by selecting specific criteria. Apply filters to
            quickly find the loans you need. You can reset or adjust filters
            anytime.
          </p>
          <div className="h-[400px] w-full flex">
            <div className="w-[30%] p-[10px] bg-[#F8F8F8] h-full overflow-y-auto">
              <div className="flex items-center justify-between">
                <p className="text-[#000000] text-[14px] font-medium">
                  Filters
                </p>
                <span className="bg-[#FFDEDE] text-[#000000] text-[12px] font-normal h-[30px] rounded-[30px] px-[10px] flex items-center justify-center">
                  {appliedFiltersCount} applied
                </span>
              </div>
              <div className="flex flex-col my-[20px] gap-[20px]">
                <FilterCard
                  label="Status"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="Role"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="Branch"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="Gender"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="From Date"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="To Date"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
              </div>
            </div>

            <div className="w-[70%] p-[10px] bg-[#FBF5F5] h-full">
              <p className="text-[#000000] text-[14px] font-medium">
                {activeTab}
              </p>
              <p className="text-[#222222] text-[14px] font-normal">
                Select your {activeTab?.toLowerCase()} filter
              </p>
              {activeTab === "Status" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[330px]">
                  {[
                    "Active",
                    "Incomplete",
                    "Rejected",
                    "Blacklisted",
                    "All",
                    "Pending Password Reset",
                  ].map((label) => (
                    <div
                      key={label}
                      className="flex mb-[20px] items-center justify-between"
                    >
                      <p className="text-[#000000] text-[14px] font-normal">
                        {label}
                      </p>
                      <input
                        type="radio"
                        name="status"
                        checked={status === label.toLowerCase()}
                        onChange={() => handleStatusSelect(label)}
                      />
                    </div>
                  ))}
                </div>
              )}
              {activeTab === "Role" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[330px]">
                  {roles?.length > 0 ? (
                    roles?.map((role) => (
                      <div
                        key={role?.id}
                        className="flex mb-[20px] items-center justify-between"
                      >
                        <p className="text-[#000000] text-[14px] font-normal">
                          {role?.name}
                        </p>
                        <input
                          type="radio"
                          name="role"
                          checked={selectedRole === role?.name}
                          onChange={() => handleRoleSelect(role?.name)}
                        />
                      </div>
                    ))
                  ) : (
                    <p>No roles data</p>
                  )}
                </div>
              )}
              {activeTab === "Branch" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[330px]">
                  {branches?.length > 0 ? (
                    branches?.map((branch) => (
                      <div
                        key={branch?.id}
                        className="flex mb-[20px] items-center justify-between"
                      >
                        <p className="text-[#000000] text-[14px] font-normal">
                          {branch?.name}
                        </p>
                        <input
                          type="radio"
                          name="branch"
                          checked={selectedBranch === branch?.name}
                          onChange={() => handleBranchSelect(branch?.name)}
                        />
                      </div>
                    ))
                  ) : (
                    <p>No branch data</p>
                  )}
                </div>
              )}
              {activeTab === "Gender" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[330px] overflow-y-auto">
                  {["Male", "Female"].map((gender) => (
                    <div
                      key={gender}
                      className="flex mb-[20px] items-center justify-between"
                    >
                      <p className="text-[#000000] text-[14px] font-normal">
                        {gender}
                      </p>
                      <input
                        type="radio"
                        name="gender"
                        checked={selectedGender === gender}
                        onChange={() => setSelectedGender(gender)}
                      />
                    </div>
                  ))}
                </div>
              )}
              {activeTab === "From Date" && (
                <div className="w-full flex items-start justify-center mt-[10px] p-[10px] h-full overflow-y-auto">
                  <Calendar
                    onChange={setFromDate}
                    value={fromDate}
                    maxDate={toDate || new Date()}
                  />
                </div>
              )}
              {activeTab === "To Date" && (
                <div className="w-full flex items-start justify-center mt-[10px] p-[10px] h-full overflow-y-auto">
                  <Calendar
                    onChange={setToDate}
                    value={toDate}
                    minDate={fromDate}
                    maxDate={new Date()}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFilter;
